import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { lerBuscaSimulador, SimuladorPage, type BuscaSimulador } from '@/components/simulador';

export const Route = createFileRoute('/_app/precificar/simulador')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaSimulador(bruto),
  component: SimuladorRota,
});

function SimuladorRota() {
  const busca = Route.useSearch();
  const navigate = useNavigate();
  const onNavegar = (nova: BuscaSimulador, opcoes?: { replace?: boolean }) => {
    void navigate({ to: '/precificar/simulador', search: nova, replace: opcoes?.replace });
  };
  return <SimuladorPage busca={busca} onNavegar={onNavegar} />;
}
